import React from "react";

/**
 * FilePreview
 * Props:
 *  - label: string -> Label for the file input / preview
 *  - file: object | null -> File object with at least { file_name, ... }
 *  - onClick: function -> Callback when user clicks the file preview
 */
const FilePreview = ({ label, file, onClick,disabled=false}) => {
  return (
    <div className="">
      {/* Label */}
      <div className="flex items-center justify-between">
        <label
          className="text-sm text-labelColour whitespace-normal break-words block"
        >
          {label}
        </label>
      </div>

      {/* File Preview */}
      {file && (
        <div
          onClick={(e) => {
            e.preventDefault();
            onClick(file);
          }}
          className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
        >
          <div className="flex flex-col">
            <span className="text-black underline">{file.file_name}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilePreview;
